import {
  SET_PAGELOADINGSTATUS,
  SetPageStatusAction,
  UPDATE_CURRENT_PAGE,
  UpdateCurrentPageAction
} from './actions';
import { BasePageModel } from 'models/BasePageModel';
import { LoadingStatus } from 'models/LoadingStatus';
import productListPage from 'views/ProductlistPage/reducer';
import checkoutPage from 'views/CheckoutPage/reducer';
import conservatoryReducer from 'views/ConservatoryPage/reducer';
import productPage from 'views/ProductPage/reducer';
import ppiPage from 'views/PPI/reducer';
import favouritesPage from 'views/FavouritesPage/reducer';
import initialPageState from 'components/Pagelayout/initialPageState';
import { Action, compose, Reducer } from 'redux';
import { createReducer } from 'store/createReducer';
import editorialPage from 'views/EditorialPage/reducer';
import customerPage from 'views/CustomerPage/reducer';

const pageReducer = createReducer(initialPageState, {
  [UPDATE_CURRENT_PAGE]: (_: BasePageModel, action: UpdateCurrentPageAction) => {
    return action.newPage;
  },
  [SET_PAGELOADINGSTATUS]: (state: BasePageModel, action: SetPageStatusAction) => {
    return { ...state, status: action.status };
  }
});

export const headerReducer = {
  [UPDATE_CURRENT_PAGE]: (state: BasePageModel) => {
    return { ...state, status: LoadingStatus.Completed };
  },
  [SET_PAGELOADINGSTATUS]: (state: BasePageModel, { status }: SetPageStatusAction) => {
    return {
      ...state,
      status
    };
  }
};

interface Reducers<S> {
  [key: string]: Reducer<S>;
}

function createPageReducers<S extends BasePageModel>(initialState: S, reducers: Reducers<S>) {
  return (state: S = initialState, action: Action) => {
    const reducer = state.componentName in reducers ? reducers[state.componentName] : (s: S) => s;
    return compose((s: S) => pageReducer(s, action), reducer)(state, action);
  };
}

export default createPageReducers(initialPageState, {
  ProductlistPage: productListPage,
  SearchProductlistPage: productListPage,
  ConservatoryPage: conservatoryReducer,
  CheckoutPage: checkoutPage,
  PpiPage: ppiPage,
  ProductPage: productPage,
  EditorialPage: editorialPage,
  FavouritesPage: favouritesPage,
  CustomerPage: customerPage
});
